import {texture} from "../../core/AssetHelpers";
import {Particles} from "../../core/Particles";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {AnimationContext} from "./AnimationContext";

export class ParticlesAngSleep extends Particles {

    constructor(item: SceneItem, context: AnimationContext, cb: Callback) {
        super(texture("ang_sleepyhead_z")!, {
            alpha: {
                start: 1,
                end: 1,
            },
            scale: {
                start: 1.5,
                end: 2,
                minimumScaleMultiplier: 0.5,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 200,
                end: 400,
                minimumSpeedMultiplier: 0.8,
            },
            acceleration: {
                x: 40,
                y: 0,
            },
            maxSpeed: 0,
            startRotation: {
                min: -100,
                max: -80,
            },
            noRotation: true,
            rotationSpeed: {
                min: 0,
                max: 0,
            },
            lifetime: {
                min: 3,
                max: 4,
            },
            blendMode: "normal",
            frequency: 0.5,
            emitterLifetime: -1,
            maxParticles: 100,
            pos: {
                x: 0.5 * item.width / item.scale.x,
                y: 0.5 * item.height / item.scale.y,
            },
            addAtBack: false,
            spawnType: "point",
        });
        this.emitter.emit = true;
        this.emitter.autoUpdate = true;
        item.addChild(this);
        cb();
    }
}
